import React, { useCallback, useEffect, useState } from 'react'
import './Common.scss'
import RightArrow from '../../../../admin/common/icons/right-arrow'
import SearchIcon from '../../../../admin/common/icons/SearchIcon'
import CloseIcon from '../../../../admin/common/icons/CloseIcon'
import { useTranslation } from 'react-i18next'
import { Link, useNavigate } from 'react-router-dom'
import { _Api } from '../../../common/api'
import CrossIcon from '../../assets/icons/CrossIcon'
import UserIcon from '../../../../admin/common/icons/UserIcon'
import AppoinmentIcon from '../../assets/icons/AppoinmentIcon'
import ChangePasswordIcon from '../../assets/icons/ChangePasswordIcon'
import SignupBackImg from "../../assets/icons/SignUpBackIcon";
import PurchaseChart from "../../assets/icons/CartIcon";
import CartIcon from '../../assets/icons/CartIcon'
import LikeNotific from "../../assets/images/LikeIcon.png";
import HomeIcon from '../../assets/icons/HomeIcon'
import HeartIcon from '../../../../admin/common/icons/HeartIcon'
import Shoppingbag from '../../../../admin/common/icons/Shoppingbag'
import SignUpBackIcon from '../../assets/icons/SignUpBackIcon'
import LeftArrow from 'Ecommerce/common/icons/LeftArrow'
import RightSideArrow from 'Ecommerce/template_four/assets/icons/RightSideArrow'
import RightIcon from 'admin/common/icons/sidebar/RightIcon'
import LeftIcon from 'admin/common/icons/sidebar/LeftIcon'
import ArrowDownside from '../../assets/icons/ArrowDownSide';

export default function CommonDropdown({type, openmodal, setOpenmodal, handleCloseCommonPopup}) {
    const {i18n,t} = useTranslation();
    const navigate = useNavigate();
    let cartdata = JSON.parse(localStorage.getItem("CartItems"));
    const [LanguageList, setLanguageData] = useState(null);
    const base_assets = process.env.REACT_APP_BASE_ASSETS_URL;
    const [CurrentLan_flg, setLanguageSelectData] = useState({ Lan_photo: 'US.png', lang: "English" })
    const accessToken = localStorage.getItem("ecomaccesstoken");
    const [searchlist, setSearchlist] = useState([]);
    const [isSearchOpen, setIsSearchOpen] = useState(false);
    const [wishlistcounts, setWishlistcounts] = useState();
    const [languageDropdown, setLanguageDrodown] = useState(false);
    const [menubar, setMenubar] = useState(false);
    const [headerTag, setHeaderTag] = useState('');
    const [headerdata, setHeaderdata] = useState([]);
    const [activeMenu, setActiveMenu] = useState('');
    const [activeDynamicItem, setActiveDynamicItem] = useState(null);
    const [activeDropdowns, setActiveDropdowns] = useState([false]);
    const [searchloading , setsearchloading] = useState(false);
    const [searchval , setsearchval] = useState('');
    const Headerstaics = async () => {
        try {
            let postdata = {
                type: "menu",
            };
            let res = await _Api(postdata, `redis/menu`);
            if (res?.statusCode === 200) {
                setHeaderdata(res?.data?.menu);
            }
        } catch (err) {
            console.log(err, "err");
        }
    };
    useEffect(()=>{
       console.log('hhhsss',activeDynamicItem)
    },[activeDynamicItem])

    useEffect(()=>{
        Headerstaics();
        languagedata();
    },[])

    const headerSearchToggle = () => {
        setIsSearchOpen(!isSearchOpen);
    };

    const rtlView = useCallback((type, l) => {
        
        var jsonData = JSON.stringify(l);
        localStorage.setItem("UserLangecom", jsonData);
        setLanguageSelectData(l)
        let bodyid = document.querySelector("#body_id");
        if (type === "rtl") {
            bodyid.classList.add("rtl");
        } else {
            bodyid.classList.remove("rtl");
        }
    }, [setLanguageSelectData]);
    
    const alllogindata = (keyName, value) => {
        setOpenmodal((prevState) => ({
            ...prevState,
            [keyName]: value,
        }));
    };
    const searchdropdonwn = async (event) => {
        try {
            setsearchloading(true)
            let postdata = {
                search: event,
            };
            let res = await _Api(postdata, `product/search`);
            if (res?.statusCode === 200) {
                setSearchlist(res?.data);
            }
        } catch (err) {
            console.log(err, "err");
        }finally{
            setsearchloading(false)
        }
    };
    const languagedata = async () => {
        try {
            let postdata = {};
            let res = await _Api(postdata, `language`);
            if (res?.statusCode === 200) {
                setLanguageData(res?.data);
            }
        } catch (err) {
            console.log(err, "err");
        }
    };
    const toggleDropdown = (index) => {
        if (activeDropdowns !== index) {
            if (activeDropdowns[index]) {
                setActiveDropdowns((prev) => {
                    return [false]
                })
            } else {
                setActiveDropdowns((prev) => {
                    const newDropdowns = [];
                    newDropdowns[index] = !newDropdowns[index];
                    return newDropdowns;
                });
            }
        } else {
            setActiveDropdowns((prev) => {
                return [false]
            })
        }
    };
  return (
    <div className='commonMenubar templatefourcommonmenubar' onClick={handleCloseCommonPopup}>
        <div className='commonMenubar-inner' onClick={(e)=> e.stopPropagation()}>
            {/* <span className='commonMenubar-inner-back' >
                <RightArrow/>
            </span> */}
            { type === 'Search' ? 

            //search 

            <div className='commonMenubar-inner-searchsection'>
            
            <div className='commonMenubar-inner-header'>
                {/* {t("Search")} */}
                <span  onClick={handleCloseCommonPopup}><CloseIcon/></span>
            </div>
            <div className='commonMenubar-inner-searchsection-bar'>
                <input type='text' className='commonMenubar-inner-searchsection-bar-input' value={searchval} placeholder='Search products...' onChange={(e) =>{setsearchval(e.target.value); searchdropdonwn(e.target.value)}}/>
                
                <span className='commonMenubar-inner-searchsection-bar-icon right'>{searchval ? <span  className='clear' onClick={()=>{ setsearchval('');setsearchloading(false);setSearchlist([])}}>CLEAR</span> : null}<SearchIcon/></span>
                
            </div>
            {/* <div className='commonMenubar-inner-searchsection-suggestion'>
                <div className='commonMenubar-inner-searchsection-suggestion-item'>
                    {t("Bracelate")}
                </div>
            </div> */}
            {/* <div className='commonMenubar-inner-header'>
                {t("Suggested")}
            </div> */}
            <div className='commonMenubar-inner-searchsection-list'>
                <div className='commonMenubar-inner-searchsection-list-item'>
                {searchlist?.length ? 
                    searchlist.map((result, key) => {
                        return (
                            <Link
                                className="commonMenubar-inner-searchsection-list-item-detail"
                                to={`product/${result?.Slug}`}
                                state={{ id: result?._id }}
                                key={key}
                            >
                                <div className='imageWrapper'>
                                <img className="searchresultimg" src={result?.main_image} alt={result?.name} />
                                </div>
                                <div className='details'>
                                    <p className="p-0 m-0" >
                                        {result?.name}
                                    </p>
                                    <p className="p-0 m-0" >
                                        {result?.item_name ?? "Ring"} ||{" "}
                                        {result?.SKU}{" "}
                                    </p>
                                </div>
                            </Link>
                                )})

                                : searchval && !searchloading ? <div style={{marginLeft:'10px'}}>No Data Found</div> : <ul className='popularserches'>
                                <li >Popular searches</li>
                                  <li onClick={()=>{searchdropdonwn('bracelet'); setsearchval('bracelet')}}>Bracelets</li>
                                  <li onClick={()=> {searchdropdonwn('earring'); setsearchval('earring')}}>Earrings</li>
                                  <li onClick={()=>{searchdropdonwn('necklace');  setsearchval('necklace')}}>Necklaces & Pendants</li>
                                  <li onClick={()=> {searchdropdonwn('ring'); setsearchval('Rings')}}>Rings</li>
                                </ul>
                // : searchloading ? 
                // : <div className='commonMenubar-inner-searchsection-list-item-details'><span><SearchIcon/></span><span>{t("No suggetions yet !")}</span></div> }
                            } 
                </div>
            </div>
            </div>
            :

            //menubar
            <div className='commonMenubar-inner-menubar'>
                {headerTag ?
                    <div className='commonMenubar-inner-header'>
                    <span className='cursor-pointer' onClick={()=>{setHeaderTag(null);setActiveDynamicItem(null)}}><LeftIcon/></span> 
                    <span>{headerTag}</span>
                    <span className='cursor-pointer' onClick={handleCloseCommonPopup}><CloseIcon/></span>
                    </div>
                    :
                    <div className='commonMenubar-inner-header'>
                    <span className='closeicon' onClick={handleCloseCommonPopup}><CloseIcon/></span>
                    </div>
                }
                <div className='commonMenubar-inner-menubar-list'>
                    <div className='commonMenubar-inner-menubar-list-items'>
                     { headerTag === 'Languages' ? 
                     
                     <div>
                        <div className='commonMenubar-inner-menubar-list-items-head'>{t("Language")}</div>
                         {LanguageList?.map((LanguageCode, key) => (
                                <div className='' key={key}>
                                    {LanguageCode.Lan_value === "arabic" ? (
                                        <div
                                        className='commonMenubar-inner-menubar-list-items-menuitem'
                                        onClick={() => {
                                            i18n.changeLanguage(LanguageCode.Lan_value);
                                            rtlView("rtl", {
                                                Lan_photo: LanguageCode?.Lan_photo,
                                                lang: LanguageCode?.Lan_value
                                            });
                                            setMenubar(false)
                                        }}
                                        >
                                            <span>{LanguageCode.Lan_text}</span>
                                        <div className="ecom-radiobtndark" >
                                          <input type="radio" className="ecom-radiobtndark-inputField"
                                              id={LanguageCode?.Lan_text + key} name="shiphome"
                                              checked={CurrentLan_flg?.lang === LanguageCode?.Lan_value ? true : false }
                                          />
                                          <label className="ecom-radiobtndark-labeltext"
                                              htmlFor={LanguageCode?.Lan_text + key}
                                              >

                                              </label>
                                      </div>
                                      </div>
                                    ) : (
                                        <div
                                        className='commonMenubar-inner-menubar-list-items-menuitem'
                                        onClick={() => {
                                            i18n.changeLanguage(LanguageCode.Lan_value);
                                            rtlView("ltr",
                                                {
                                                    Lan_photo: LanguageCode?.Lan_photo,
                                                    lang: LanguageCode?.Lan_value
                                                });
                                            setMenubar(false)
                                        }}
                                        >
                                        
                                            <span>{LanguageCode.Lan_text}</span>
                                        <div className="ecom-radiobtndark" >
                                          <input type="radio" className="ecom-radiobtndark-inputField"
                                              id={LanguageCode?.Lan_text + key} name="shiphome"
                                              checked={CurrentLan_flg?.lang === LanguageCode?.Lan_value ? true : false }
                                          />
                                          <label className="ecom-radiobtndark-labeltext"
                                              htmlFor={LanguageCode?.Lan_text + key}
                                              >

                                              </label>
                                      </div>
                                        </div>
                                    )}
                                </div>
                            ))}
                     </div>
                     : headerTag === 'Category' ? 
                                                       <>
                                                 
                                                            {headerdata?.[0]?.subcategories?.length
                                                                ? headerdata?.[0]?.subcategories?.map((element, index) => {
                                                                    return (
                                                                        <>
                                                                        <div  onClick={()=> element.subcategories?.length ? setActiveDynamicItem({name:'Category', index : index}) : navigate(`Category/${element?.slug}`)} className="commonMenubar-inner-menubar-list-items-menuitem " key={index}>
                                                                                <span className='commonMenubar-inner-menubar-list-items-menuitem-textholder'>
                                                                                        {element?.name}
                                                                                </span>
                                                                                <span className='commonMenubar-inner-menubar-list-items-menuitem-iconholder'> { element.subcategories?.length  ? <RightArrow onClick={()=>setActiveDynamicItem({name:'Category', index : index})} /> : null }</span>
                                                                            
                                                                        </div>
                                                                        { element.subcategories?.length && activeDynamicItem?.name === 'Category' && activeDynamicItem?.index === index ?
                                                                            element.subcategories.map((item, i)=>{
                                                                                return(
                                                                                    <Link to={`Category/${item?.slug}`} className="commonMenubar-inner-menubar-list-items-menuitem " key={`subcat${i}`}>
                                                                                            <span className='commonMenubar-inner-menubar-list-items-menuitem-textholder'>
                                                                                                    {item.name}
                                                                                            </span>
                                                                                    </Link>
                                                                                )
                                                                            })
                                                                         : null }
                                                                        </>
                                                                    )

                                                                })
                                                                : ""}
                                                                
                                                      </>
                                               
                    : headerTag === 'Collection' ?

                    <>
                                                            {headerdata?.[1]?.subcategories?.length
                                                                ? headerdata?.[1]?.subcategories?.map((element, index) => {
                                                                    return (
                                                                        <>
                                                                        <div  onClick={()=> element.subcategories?.length ? setActiveDynamicItem({name:'Collection', index : index}) : navigate(`Collection/${element?.slug}`)} className="commonMenubar-inner-menubar-list-items-menuitem " key={index}>
                                                                                <span className='commonMenubar-inner-menubar-list-items-menuitem-textholder'>
                                                                                        {element?.name}
                                                                                </span>
                                                                                <span className='commonMenubar-inner-menubar-list-items-menuitem-iconholder'> { element.subcategories?.length  ? <RightArrow onClick={()=>setActiveDynamicItem({name:'Collection', index : index})} /> : null }</span>
                                                                            
                                                                        </div>
                                                                        { element.subcategories?.length && activeDynamicItem?.name === 'Collection' && activeDynamicItem?.index === index ?
                                                                            element.subcategories.map((item, i)=>{
                                                                                return(
                                                                                    <Link to={`Collection/${item?.slug}`} className="commonMenubar-inner-menubar-list-items-menuitem " key={`sub${i}`}>
                                                                                            <span className='commonMenubar-inner-menubar-list-items-menuitem-textholder'>
                                                                                                    {item.name}
                                                                                            </span>
                                                                                    </Link>
                                                                                )
                                                                            })
                                                                         : null }
                                                                        </>
                                                                    )

                                                                })
                                                                : ""}
                                                                
                                                      </>
                    :
                    <>
                    {headerdata?.length ?
                                    headerdata.map((result, key) => {
                                        return (
                                            <React.Fragment key={key}>
                                                <div className='commonMenubar-inner-menubar-list-items-menuitem' 
                                                        onClick={() =>{
                                                            // activeMenu === result.name ? setActiveMenu('') : setActiveMenu(result.name)
                                                            if(!result.subcategories?.length){navigate(`/${result?.slug ? result?.slug : null}`)}
                                                            setHeaderTag(result.name)
                                                         } }
                                                >
                                                    <span className='commonMenubar-inner-menubar-list-items-menuitem-textholder'>
                                                    {t(`${result.name}`)}
                                                    </span>
                                                    <span className='commonMenubar-inner-menubar-list-items-menuitem-iconholder' onClick={()=>{
                                                       if(result.subcategories?.length){ if(activeDynamicItem?.index === key){setActiveDynamicItem(null)}else{
                                                        setActiveDynamicItem({name:key, index : key})
                                                       }}
                                                        }}>
                                                    { result.subcategories?.length  ?( activeDynamicItem?.index === key ? <ArrowDownside />:<RightArrow /> ) : null }
                                                        
                                                    </span>
                                                </div>
                                                { result.subcategories?.length  && activeDynamicItem?.name === key && activeDynamicItem?.index === key ?
                                                                            result.subcategories.map((item, i)=>{
                                                                                return(
                                                                                    <Link to={`${result?.slug ? result.slug : ''}/${item?.slug}`} className="commonMenubar-inner-menubar-list-items-menuitem " key={`sub${i}`}>
                                                                                            <span style={{paddingLeft:'20px' ,color:'#2f2f2f'}} className='commonMenubar-inner-menubar-list-items-menuitem-textholder'>
                                                                                                    {item.name}
                                                                                            </span>
                                                                                    </Link>
                                                                                )
                                                                            })
                                                                         : null }
                                            </React.Fragment>
                                        )
                                    }) : ""}
                         <Link
                            to="/appointment"
                            className="commonMenubar-inner-menubar-list-items-menuitem"
                            // onClick={()=>alllogindata("showLoginModel", true)}
                            >
                                <span className='commonMenubar-inner-menubar-list-items-menuitem-textholder'>{t("Book an Appointment")}</span>
                        </Link>
                        <Link
                            to="/contactus"
                            className="commonMenubar-inner-menubar-list-items-menuitem"
                            // onClick={()=>alllogindata("showLoginModel", true)}
                            >
                                <span className='commonMenubar-inner-menubar-list-items-menuitem-textholder'>{t("Contact Us")}</span>
                        </Link>
                    </>
                    }
                    </div>
                    <div className='commonMenubar-inner-menubar-list-bottom'>
                    {accessToken ? 
                        <>
                        {/* <Link
                        className="commonMenubar-inner-menubar-list-items-menuitem"
                        to="/account"
                        >
                            <span className='commonMenubar-inner-menubar-list-items-menuitem-iconholder filled'>
                                <UserIcon/>
                            </span>
                            <span className='commonMenubar-inner-menubar-list-items-menuitem-textholder'>{t("My Account")}</span>
                        </Link>
                        <Link
                        to="/logout"
                        className="commonMenubar-inner-menubar-list-items-menuitem">
                            <span className="commonMenubar-inner-menubar-list-items-menuitem-iconholder">
                                <SignUpBackIcon/>
                            </span>
                            <span className='commonMenubar-inner-menubar-list-items-menuitem-textholder'>{t("Sign Out")}</span>
                        </Link> */}
                        </>
                        :
                        <div className='commonMenubar-inner-menubar-list-bottom-login'>
                            <button className='themeBtn'  onClick={()=>alllogindata("showLoginModel", true)}>
                                {t("Log In")}
                            </button>
                            <span className='text'>{t("New Customer")}? <span className='text-special cursor-pointer'  onClick={()=>alllogindata("showRegisterModel", true)}>{t("Create My Account")}</span></span>
                        </div>
                        }
                    <div className="commonMenubar-inner-menubar-list-bottom-language" 
                     onClick={() =>
                        setHeaderTag('Languages')
                    }
                    >
                                <img
                                    style={{
                                        width: "24px",
                                        height: "24px"
                                    }}
                                    className="rounded-0 shadow-lg"
                                    src={base_assets + 'images/flags/' + CurrentLan_flg?.Lan_photo}
                                    alt="icon"
                                />
                                <span className="language-showSelctLang">{CurrentLan_flg?.lang}</span>
                                <span className='dropdown'><RightIcon/></span>
                    </div>
                    </div>
                </div>
            {/* <div className="rightSideContentBox3">
           
            {accessToken ? (
                <div className="dropdown rightSideContentBox-accountDropBox userAccountBoxMain">
                    <button
                        className="com-transBtn rightSideContentBox-btnBox dropdown-toggle"
                        id="headeraccountdropdown"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                    >
                        <span>
                            <UserIcon />
                        </span>
                    </button>
                    <ul
                        className="dropdown-menu rightSideContentBox-accountDropBox-listBox"
                        aria-labelledby="headeraccountdropdown"
                    >
                        {accessToken ? (
                            <li>
                                <Link
                                    className="dropdown-item rightSideContentBox-accountDropBox-listBox-SingleList"
                                    to="/account"
                                >
                                    <span className="rightSideContentBox-accountDropBox-listBox-SingleList-imgBox">
                                        <span>
                                            <UserIcon />
                                        </span>
                                    </span>
                                    {t("My Account")}
                                </Link>
                            </li>
                        ) : (
                            <Link
                                className="dropdown-item rightSideContentBox-accountDropBox-listBox-SingleList"
                                to="#"
                            >
                                <span className="rightSideContentBox-accountDropBox-listBox-SingleList-imgBox">
                                    <span>
                                        <UserIcon />
                                    </span>
                                </span>
                                {t("My Account")}
                            </Link>
                        )}

                        <li>
                            <Link
                                className="dropdown-item rightSideContentBox-accountDropBox-listBox-SingleList"
                                to="/account/purchasehistory"
                            >
                                <span className="rightSideContentBox-accountDropBox-listBox-SingleList-imgBox">
                                    <span>
                                        <PurchaseChart />
                                    </span>
                                </span>
                                {t("Purchase History")}
                            </Link>
                        </li>
                        <li>
                            <Link
                                className="dropdown-item rightSideContentBox-accountDropBox-listBox-SingleList"
                                to="/account/appointmentdata"
                            >
                                <span className="rightSideContentBox-accountDropBox-listBox-SingleList-imgBox">
                                    <span>
                                        <AppoinmentIcon />
                                    </span>
                                </span>
                                {t("Appointment")}
                            </Link>
                        </li>
                        <li>
                            <Link
                                className="dropdown-item rightSideContentBox-accountDropBox-listBox-SingleList"
                                to="/account/changepassword"
                            >
                                <span className="rightSideContentBox-accountDropBox-listBox-SingleList-imgBox">
                                    <span>
                                        <ChangePasswordIcon />
                                    </span>
                                </span>
                                {t("Change Password")}
                            </Link>
                        </li>
                        <li>
                            <Link
                                to="/logout"
                                className="dropdown-item rightSideContentBox-accountDropBox-listBox-SingleList p-0"
                            >
                                <div className="rightSideContentBox-accountDropBox-listBox-SingleList-SingUpBtn ">
                                    <span className="rightSideContentBox-accountDropBox-listBox-SingleList-imgBox">
                                        <span>
                                            <SignupBackImg />
                                        </span>
                                    </span>
                                    {t("Sign Out")}
                                </div>
                            </Link>
                        </li>
                    </ul>
                </div>
            ) : (
                <button
                    className="com-transBtn rightSideContentBox-btnBox user-profile-button"
                    onClick={() => alllogindata("showLoginModel", true)}
                >
                    <span>
                        <UserIcon />
                    </span>
                </button>
            )}

            <Link
                className="com-transBtn rightSideContentBox-btnBox wishlistTabBtnShow mt-1"
                type="submit"
                to="/wishlist"
            >
                <img
                    src={LikeNotific}
                    className="rightSideContentBox-btnBox-imgShow"
                    alt=""
                />
                {wishlistcounts ?
                    <span className="product-count">
                        {wishlistcounts ? wishlistcounts : 0}
                    </span> : ""}

            </Link>

            <Link
                to="/shoppingcart"
                className="com-transBtn rightSideContentBox-btnBox cartTabIconhide mt-1"
                type="submit"
            >
                <img
                    src={CartIcon}
                    className="rightSideContentBox-btnBox-imgShow"
                    alt=""
                />
                {cartdata?.length ?
                    <span className="product-count">
                        {cartdata?.length ? cartdata?.length : 0}
                    </span> : ""}
            </Link>
            <li className="rightSideContentBox-languagedropDown dropdown rounded-0  shadow-none list-unstyled">
                <button
                    className="dropdown-toggle border-0 bg-transparent rightSideContentBox-languagedropDown-mainLangToggle showArrowDropdown mt-2"
                    type="button"
                    id="languagedropdown"
                    data-bs-toggle="dropdown"
                    aria-expanded={!languageDropdown}
                    onClick={() => setLanguageDrodown(!languageDropdown)}>
                    <div className="d-flex gap-2">
                        <img
                            style={{
                                width: "24px",
                                height: "24px"
                            }}
                            className="rounded-0 shadow-lg"
                            src={base_assets + 'images/flags/' + CurrentLan_flg?.Lan_photo}
                            alt="icon"
                        />
                        <p className="language-showSelctLang">{CurrentLan_flg?.lang}</p>
                    </div>
                    <div className={languageDropdown ? "rotateImg" : ""}>
                        <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="#000"
                            xmlns="http://www.w3.org/2000/svg"

                        >
                            <path
                                d="M9 18L15 12L9 6"
                                stroke="#000"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                        </svg>
                    </div>
                </button>
                <ul
                    className="dropdown-menu dropdown-menu-end rightSideContentBox-languagedropDown-langListBox"
                    aria-labelledby="languagedropdown"
                >
                    {LanguageList?.map((LanguageCode, key) => (
                        <li key={key}>
                            {LanguageCode.Lan_value === "arabic" ? (
                                <Link
                                    className="dropdown-item rightSideContentBox-languagedropDown-langListBox-langSingleList"
                                    onClick={() => {
                                        i18n.changeLanguage(LanguageCode.Lan_value);
                                        rtlView("rtl", {
                                            Lan_photo: LanguageCode?.Lan_photo,
                                            lang: LanguageCode?.Lan_value
                                        });
                                        setMenubar(false)
                                    }}
                                    data-bs-toggle="collapse"
                                    data-bs-target="#navbarSupportedContent"
                                >
                                    <img
                                        src={
                                            base_assets +
                                            "images/flags/" +
                                            LanguageCode.Lan_photo
                                        }
                                        alt=""
                                    />{" "}
                                    <span>{LanguageCode.Lan_text}</span>
                                </Link>
                            ) : (
                                <Link
                                    className="dropdown-item rightSideContentBox-languagedropDown-langListBox-langSingleList"
                                    onClick={() => {
                                        i18n.changeLanguage(LanguageCode.Lan_value);
                                        rtlView("ltr",
                                            {
                                                Lan_photo: LanguageCode?.Lan_photo,
                                                lang: LanguageCode?.Lan_value
                                            });
                                        setMenubar(false)
                                    }}
                                    data-bs-toggle="collapse"
                                    data-bs-target="#navbarSupportedContent"
                                >
                                    <img
                                        style={{
                                            width: "25px",
                                            height: "100%",
                                        }}
                                        src={
                                            base_assets +
                                            "images/flags/" +
                                            LanguageCode.Lan_photo
                                        }
                                        alt=""
                                    />{" "}
                                    <span>{LanguageCode.Lan_text}</span>
                                </Link>
                            )}
                        </li>
                    ))}
                </ul>
            </li>
             </div> */}
             </div>
            }
        </div>
    </div>
  )
}
